import {
  getJsonAsync, 
  postJsonAsync, 
  navigateTo
} from 'shared/actions';
import {
  getLoggedInUser, 
  goToProfile
} from 'shared/auth/actions';
import {
  displayActiveTournaments,
  displayBirthDateModal,
  displayRequiredProfileFieldsModal,
  setTournamentLoading
} from './actionTypes'; 

export const handleScheduleClick = tournamentId => (dispatch, getState) => {
  const authState = getState().shared.auth;

  getLoggedInUser()
  .then((user) => {
    if (user && !authState.profileIsConfirmed)
    {
      return;
    } else if (user && !authState.profileIsValid)
    {
      dispatch(displayRequiredProfileFieldsModal(true));
    } else {
      dispatch(navigateTo(`registration/schedule/${tournamentId}`));
    }
  });
};

export const handleResendEmailClick = tournamentId => (dispatch, getState) => {
  const authState = getState().shared.auth;

  getLoggedInUser()
  .then((user) => {
    if (user && !authState.profileIsConfirmed)
    {
      return;
    } else if (user && !authState.profileIsValid)
    {
      dispatch(displayRequiredProfileFieldsModal(true));
    } else {
      dispatch(navigateTo(`registration/schedule/${tournamentId}`));
    }
  });
};

export const handleManageClick = tournamentId => (dispatch, getState) =>{
  const authState = getState().shared.auth;

  getLoggedInUser()
  .then((user) => {
    if (user && !authState.profileIsConfirmed)
    {
      return;
    } else if (user && !authState.profileIsValid)
    {
      dispatch(displayRequiredProfileFieldsModal(true));
    } else {
      dispatch(navigateTo(`registration/manage/${tournamentId}`));
    } 
  });
};

export const retrieveActiveTournaments = query => dispatch => {
  dispatch(setTournamentLoading());
  dispatch(postJsonAsync(`registration/tournament/active`, query))
  .then(data => dispatch(displayActiveTournaments(data)))
  .catch(() => {});
};

export const handleSendToProfile = () => dispatch => {
  dispatch(goToProfile()); 
};

export const handleBirthDateModalCancel = () => dispatch => {
  dispatch(displayBirthDateModal(false));
};

export const handleRequiredProfileFieldsModalCancel = () => dispatch => {
  dispatch(displayRequiredProfileFieldsModal(false));
};

export const handleTournamentSearch = () => (dispatch, getState) => {
  const home = getState().registration.home;
  let searchValue = home.searchValue;

  if (searchValue && searchValue.length > 0) searchValue = searchValue.toLowerCase();
  dispatch(setTournamentLoading());

  dispatch(getJsonAsync(`registration/tournament/active`))
    .then(data => {
      if (searchValue && searchValue.length > 0) {
        data = data.filter(d => d.name.toLowerCase().indexOf(searchValue) > -1);
      }
      dispatch(displayActiveTournaments(data));
    })
    .catch(() => { });
};

export const handleTournamentSearchEnterKeyPress = event => dispatch => {
  if (event.keyCode === 13) {
    event.preventDefault();
    event.stopPropagation();
    dispatch(handleTournamentSearch());
  }
};



// WEBPACK FOOTER //
// ./src/features/registration/home/actions.js